import { IChatMsgAPI, IChatMsgAPI_HI } from "../Interfaces";
import { ExplorerAPI } from "./ExplorerAPI";


export class MsgReceive {
    constructor(chatMsg: IChatMsgAPI_HI) {
        const _chatMsg: IChatMsgAPI = {
            ...chatMsg,
            messageType: "MessageReceive",
            time: Date.now(),
            child: {
                componentName: "Text",
                props: {
                    text: chatMsg.text
                }
            }
        }
        new ExplorerAPI.MsgReceive({ ..._chatMsg });
    }
}